export default __webpack_public_path__ + "static/media/CVpolaroid_PlymouthSciencePark.8b689879.png";